import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { SeoActions, SeoPageState, SeoSelectors, StateWithSeo } from '@seo/data-access';
import { CustomPageMeta } from '@shared/models';
import { Observable, map } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SeoPageService {
  constructor(private store: Store<StateWithSeo>) {}

  loadPage(urlOrLabel: string, baseStoreCode: string): void {
    this.store.dispatch(new SeoActions.PageLoad({ urlOrLabel, baseStoreCode }));
  }

  getPage(): Observable<SeoPageState | null> {
    return this.store.select(SeoSelectors.getPageValue);
  }

  getSeoPage(): Observable<CustomPageMeta | null> {
    return this.getPage().pipe(
      map((page) => {
        if (!page || !page.seo) {
          return null;
        }

        return {
          title: page.seo.metaTitle,
          heading: page.seo.h1,
          description: page.seo.metaDescription,
          robots: page.seo.metaRobots ? [page.seo.metaRobots] : [],
          breadcrumbs: [
            {
              label: 'главная',
              link: '/',
            },
            { label: page.seo.breadcrumbTitle || page.seo.h1 || '', link: '' },
          ],
          canonicalUrl: page.seo.canonicalURL,
        };
      }),
    );
  }

  isLoading(): Observable<boolean> {
    return this.store.select(SeoSelectors.getPageLoading);
  }

  isSuccess(): Observable<boolean> {
    return this.store.select(SeoSelectors.getPageSuccess);
  }

  isError(): Observable<boolean> {
    return this.store.select(SeoSelectors.getPageError);
  }
}
